import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-input-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "floating-label" }
const _hoisted_5 = ["rows", "placeholder", "disabled", "value"]
const _hoisted_6 = ["type", "placeholder", "disabled", "value"]
const _hoisted_7 = {
  key: 0,
  class: "meta"
}
const _hoisted_8 = {
  key: 0,
  class: "error-text"
}
const _hoisted_9 = {
  key: 1,
  class: "counter"
}

import type {Component} from "vue";
import {computed, ref} from "vue";
import {IComponentInputEmits, IComponentInputProps} from "@/types/main";
import {vMaska} from 'maska/vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonInput',
  props: {
    modelValue: { default: "" },
    label: { default: "Input" },
    placeholder: { default: "" },
    icon: {},
    appendIcon: {},
    type: { default: "text" },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { default: "" },
    maxLength: {},
    showCounter: { type: Boolean, default: false },
    multiline: { type: Boolean, default: false },
    rows: { default: 3 },
    tooManyMessage: { default: "Too many symbols" },
    mask: {}
  },
  emits: ["update:modelValue", "focus", "blur", "appendIconClick", "mask:completed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isFocused = ref(false);

const lengthNow = computed(() => props.modelValue.length);

const isTooLong = computed(() => {
  if (!props.maxLength) return false;
  return lengthNow.value > props.maxLength;
});

const isActive = computed(() => isFocused.value || lengthNow.value > 0);
const isDisabledFilled = computed(() => props.disabled && lengthNow.value > 0);

const hasError = computed(() => props.error || isTooLong.value);

const finalErrorMessage = computed(() => {
  if (isTooLong.value) return props.tooManyMessage;
  return props.errorMessage;
});

const counterText = computed(() => {
  if (!props.showCounter || !props.maxLength) return "";
  return `${lengthNow.value}/${props.maxLength}`;
});

function onInput(e: Event) {
  const input = e.target as HTMLInputElement
  let val = input.value

  if (!props.mask) {
    val = val.replace(/^\s+/, '')
    val = val.replace(/\s{2,}/g, ' ')
    if (input.value !== val) input.value = val
  }

  emit("update:modelValue", val)
}

function onMaska(e: Event) {
  const detail = (e as CustomEvent).detail
  emit('update:modelValue', detail?.masked ?? (e.target as HTMLInputElement).value)
  emit('mask:completed', !!detail?.completed)
}

function onFocus() {
  isFocused.value = true;
  emit("focus");
}

function onBlur() {
  isFocused.value = false;
  emit("blur");
}

const appendIconClick = () => {
  emit("appendIconClick")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-input", {
        'is-active': isActive.value,
        'is-error': hasError.value,
        'is-too-long': isTooLong.value,
        'is-disabled': __props.disabled,
        'is-lg': __props.multiline,
        'is-disabled-filled': isDisabledFilled.value,
      }])
    }, [
      (__props.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), { size: 20 }))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.label), 1),
        (__props.multiline)
          ? (_openBlock(), _createElementBlock("textarea", {
              key: 0,
              class: "control",
              autocomplete: "off",
              rows: __props.rows,
              placeholder: isActive.value ? __props.placeholder : '',
              disabled: __props.disabled,
              value: __props.modelValue,
              onInput: onInput,
              onFocus: onFocus,
              onBlur: onBlur
            }, null, 40, _hoisted_5))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "control",
              autocomplete: "nope",
              name: "random_field_123",
              type: __props.type ?? 'text',
              placeholder: isActive.value ? __props.placeholder : '',
              disabled: __props.disabled,
              value: __props.modelValue,
              onInput: onInput,
              onFocus: onFocus,
              onBlur: onBlur,
              onMaska: onMaska
            }, null, 40, _hoisted_6)), [
              [_unref(vMaska), __props.mask]
            ])
      ]),
      (__props.appendIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "append-icon",
            onClick: appendIconClick
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.appendIcon), { size: 20 }))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    ((__props.showCounter || finalErrorMessage.value))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (__props.error && finalErrorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(finalErrorMessage.value), 1))
            : _createCommentVNode("", true),
          (counterText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(counterText.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})